import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'loginForm.title',
    defaultMessage: 'Sign in',
  },
  emailPlaceholder: {
    id: 'loginForm.emailPlaceholder',
    defaultMessage: 'Email address',
  },
  passwordPlaceholder: {
    id: 'loginForm.passwordPlaceholder',
    defaultMessage: 'Password',
  },
  submitButton: {
    id: 'loginForm.submitButton',
    defaultMessage: 'Sign in',
  },
  newPassword: {
    id: 'loginForm.newPassword',
    defaultMessage: 'Create a new password',
  },
  newToWinnow: {
    id: 'loginForm.newToWinnow',
    defaultMessage: 'New to Winnow?',
  },
  createAccount: {
    id: 'loginForm.createAccount',
    defaultMessage: 'Create an account',
  },
  fieldRequired: {
    id: 'loginForm.fieldRequired',
    defaultMessage: 'This field is required',
  },
  incorrectEmailFormat: {
    id: 'loginForm.incorrectEmailFormat',
    defaultMessage: 'This is not a valid e-mail format',
  },
});
